var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionIcon = function SvgQuestionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.062,
    cy: 7.037,
    rx: 7.025,
    ry: 7,
    fill: "#004152"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35 7.96h1.135v-.228c0-.536.04-.615.548-1.17.666-.734.796-.972.796-1.518 0-.942-.637-1.507-1.692-1.507-.627 0-1.125.198-1.463.585-.249.298-.348.635-.368 1.28h.965c.02-.516.269-.804.697-.804.348 0 .577.218.577.546 0 .277-.08.406-.547.912-.618.684-.647.773-.647 1.904Zm1.345 1.468a.763.763 0 0 0-.757-.764.759.759 0 1 0 0 1.517.755.755 0 0 0 .757-.753Z",
    fill: "#fff"
  })));
};
export default SvgQuestionIcon;